import * as React from 'react';
import type { SVGProps } from 'react';

const VerifiedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y="0.5" width="18" height="18" rx="9" fill="currentColor" />
    <path
      d="M13.3718 7.76137L12.955 7.3707C12.7833 7.20977 12.5031 7.20977 12.3299 7.3707L7.95987 11.4686L5.67066 9.32268C5.49898 9.16172 5.21869 9.16172 5.04553 9.32268L4.62876 9.71334C4.45708 9.8743 4.45708 10.137 4.62876 10.2993L7.64584 13.1276C7.73242 13.2087 7.84393 13.25 7.95693 13.25C8.06994 13.25 8.18292 13.2087 8.26805 13.1276L13.3674 8.34739C13.5435 8.1837 13.5435 7.92234 13.3718 7.76137Z"
      fill="white"
    />
  </svg>
);
export default VerifiedIcon;
